import Button from 'components/Button'
import UploadResultIcon from 'components/icons/SubmitCloseIcon.js'
import React from 'react'
import { ButtonDiv, ResultDiv, ResultIconDiv, UploadMsgFlex } from './Style'

const AddConfirm = ({ onClose, file, text,finalUpload }) => {
  return (
    <UploadMsgFlex column center centerVertically>
      <ResultIconDiv>
        <UploadResultIcon />
      </ResultIconDiv>
      <ResultDiv>
        {text}
      </ResultDiv>

      <ButtonDiv>
        <Button.Secondary
          text="Close"
          width="80px"
          height="36px"
          onClick={onClose}
        />
      </ButtonDiv>
    </UploadMsgFlex>
  )
}

export default AddConfirm
